/**
 * Parse Markdown tables and convert them to structured data
 */

export function parseMarkdownTables(text) {
  if (!text) return { hasTable: false, content: text };

  // Regex to match markdown tables
  const tableRegex = /(\|.+\|\n)+/g;
  const tables = text.match(tableRegex);

  if (!tables) {
    return { hasTable: false, content: text };
  }

  return { hasTable: true, tables, content: text };
}

export function extractTableData(tableText) {
  const lines = tableText.trim().split('\n').filter(line => line.trim());

  if (lines.length < 2) return null;

  // Parse header
  const header = lines[0]
    .split('|')
    .map(cell => cell.trim())
    .filter(cell => cell);

  // Skip separator line (line with ---)
  const dataLines = lines.slice(2);

  // Parse data rows
  const rows = dataLines.map(line =>
    line
      .split('|')
      .map(cell => cell.trim())
      .filter(cell => cell)
  );

  return { header, rows };
}
